import * as React from 'react';
import { colors } from '../../../index';

const IconPencil = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 11 11",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84 1.84l2.24 2.25L3.4 9.77 1.18 7.52l5.66-5.68zm3.93-.54l-1-1a.99.99 0 00-1.4 0l-.95.96L9.66 3.5l1.11-1.12c.3-.3.3-.78 0-1.08zM.01 10.68c-.04.18.12.35.3.3l2.5-.6L.57 8.13l-.56 2.55z"
  }));
};

export default IconPencil;